export default __webpack_public_path__ + "static/media/sticker-Y.5196b519.png";